import { render, staticRenderFns } from "./ShipmentTrackingPage.vue?vue&type=template&id=5b53c42c&"
import script from "./ShipmentTrackingPage.vue?vue&type=script&lang=js&"
export * from "./ShipmentTrackingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports